import { stylesheet } from 'astroturf';
import { FunctionalComponent } from 'preact';
import { StandardCarouselItem } from '../StandardCarousel/types';
import { StandardCard } from './StandardCard';

const TILE_WIDTH_PX = 254;

const styles = stylesheet`
  @import '##/styles/import.scss';

  .tile-container {
    display: flex;
    width: 100%;
    padding: pxToVh(10);
    padding-bottom: pxToVh(5);
    height: pxToVh(162.64);

    .carousel-item {
        position: relative;
        width: pxToVw(${TILE_WIDTH_PX});
        margin-right: pxToVw(29);
        flex-shrink: 0;
    }
    
    .tile-details {
        opacity: 0.5;
        padding-top: pxToVh(6);
        flex-shrink: 0;
        max-width: pxToVw(294);

        .title {
            font-size: pxToVh(20);
            margin-bottom: pxToVh(12);
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
            height: pxToVh(23.5);
        }

        .description {
            font-size: pxToVh(16);
            line-height: 1.3;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
        }
    }
  }

  :global(.current-focus) {
    .tile-details {
      opacity: 1;
      .description {
        -webkit-line-clamp: 4;
      }
    }
  }
`;

export const EpisodeTile: FunctionalComponent<StandardCarouselItem & {
  isInbound: boolean;
  domId: string;
}> = (props) => {
  if (props.isInbound === false) {
    return <div className={styles.tileContainer} />;
  }
  return (
    <div className={styles.tileContainer}>
      <div className={styles.carouselItem}>
        <StandardCard {...Object.assign(props, { tileWidthPx: 250 })} />
      </div>
      <div className={styles.tileDetails}>
        <div className={styles.title}>{props.title}</div>
        <div className={styles.description}>{props.description}</div>
      </div>
    </div>
  );
};
